import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const createStakeholderSelector = (id: string | undefined) => (state: RootState) =>
  id === undefined ? undefined : state.entities.stakeholders.byId[id];

export const createStakeholdersSelector = (ids: string[]) =>
  createSelector(...ids.map(createStakeholderSelector), (...stakeholders) =>
    stakeholders.filter((item) => item !== undefined),
  );
